import { createSelector } from 'reselect'
import * as CardStatusRoles from 'const/CardStatusRoles'
import createStatusSelector from './createStatusSelector'

const createIsCardCompletedSelector = (cardIdSelector) => {
  const statusSelector = createStatusSelector(cardIdSelector)

  return createSelector(
    [statusSelector],
    (status) =>
      status && status.role === CardStatusRoles.COMPLETED
  )
}

export default createIsCardCompletedSelector